import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SERVICE_PATHS } from "../questionConfig";
import { useMultiStepForm, type ServiceType } from "../MultiStepFormContext";

export function ServiceTypeStep() {
  const { serviceType, selectService } = useMultiStepForm();

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-[var(--dug-text-primary)] ds-type-control-heading">
          How can we help you?
        </h2>
        <p className="text-[var(--dug-text-muted)] mt-2 ds-type-body">
          Select the option that best describes what you're looking for
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {SERVICE_PATHS.map((path, index) => {
          const isSelected = serviceType === path.id;
          const Icon = path.icon;

          return (
            <motion.button
              key={path.id}
              type="button"
              onClick={() => selectService(path.id as ServiceType)}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.02, y: -2 }}
              whileTap={{ scale: 0.98 }}
              className={`
                relative p-6 rounded-2xl border-2 text-left transition-all
                ${isSelected
                  ? "border-[var(--dug-coral)] bg-[var(--dug-coral)]/5"
                  : "border-[var(--dug-border)] hover:border-[var(--dug-coral)]/40 bg-[var(--dug-bg-surface)]"
                }
              `}
            >
              <div className="flex items-start justify-between mb-4">
                <Icon
                  className={`
                    w-5 h-5 transition-colors
                    ${isSelected ? "text-[var(--dug-coral)]" : "text-[var(--dug-text-muted)]"}
                  `}
                />

                {isSelected && (
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    className="w-5 h-5 rounded-full bg-[var(--dug-coral)] flex items-center justify-center"
                  >
                    <Check className="w-3 h-3 text-[var(--dug-text-inverse)]" />
                  </motion.div>
                )}
              </div>

              <h3
                className={`
                  text-lg font-semibold mb-1
                  ${isSelected ? "text-[var(--dug-coral)]" : "text-[var(--dug-text-primary)]"}
                `}
              >
                {path.title}
              </h3>
              <p className="text-[var(--dug-text-muted)] ds-type-body">
                {path.description}
              </p>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
